export function afterGet(record) {
  const newRecord = { ...record };
  if (!record.name) {
    newRecord.name = `${record.message.substring(0, 50)} ... `;
  }

  return newRecord;
}
